import { Card, Typography, Box, Tooltip } from "@mui/material";
import { NavLink } from "react-router-dom";

export default function ButtonNav({
  title,
  subtitle,
  icon,
  image,
  to,
  color = "#2563eb",
  disabled = false,
  disabledReason = "",
}) {
  const card = (
    <Card
      aria-disabled={disabled || undefined}
      sx={(theme) => {
        const isDark = theme.palette.mode === "dark";
        return {
          width: "100%",
          minHeight: 190,
          p: 2.2,
          borderRadius: 4,
          border: isDark
            ? "1px solid rgba(255,255,255,0.08)"
            : "1px solid rgba(0,0,0,0.08)",
          background: isDark
            ? "rgba(255,255,255,0.04)"
            : "rgba(255,255,255,0.78)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          boxShadow: isDark
            ? "0 14px 40px rgba(0,0,0,0.28)"
            : "0 14px 40px rgba(0,0,0,0.06)",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
          filter: disabled ? "grayscale(0.7)" : "none",
          transition: "transform .18s ease, box-shadow .18s ease",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          "&:hover": disabled
            ? {}
            : {
                transform: "translateY(-2px)",
                boxShadow: isDark
                  ? "0 18px 55px rgba(0,0,0,0.40)"
                  : "0 18px 55px rgba(0,0,0,0.10)",
              },
        };
      }}
    >
      {image ? (
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{ width: 78, height: 78, objectFit: "contain", mb: 1.1 }}
        />
      ) : (
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: 3,
            display: "grid",
            placeItems: "center",
            bgcolor: `${color}14`,
            border: `1px solid ${color}2A`,
            color,
            mb: 1.1,
            "& svg": { fontSize: 36, display: "block" },
          }}
        >
          {icon}
        </Box>
      )}

      <Box sx={{ width: "100%", maxWidth: 280 }}>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 950,
            lineHeight: 1.15,
            mb: subtitle ? 0.55 : 0,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {title}
        </Typography>

        {subtitle ? (
          <Typography
            sx={{
              fontSize: 12.8,
              opacity: 0.68,
              lineHeight: 1.25,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Card>
  );

  if (disabled) {
    return (
      <Tooltip title={disabledReason} arrow disableInteractive>
        <Box sx={{ width: "100%" }}>{card}</Box>
      </Tooltip>
    );
  }

  return (
    <NavLink to={to} style={{ textDecoration: "none", width: "100%" }}>
      {card}
    </NavLink>
  );
}
